<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ثبت خرید</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group
            v-show="
              hasPermission('write_created_at_in_mini_orders') ? true : false
            "
            class="col-md-6"
            label="زمان ثبت"
          >
            <date-picker
              type="datetime"
              v-model="created_at"
              :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'"
            />
          </b-form-group>
          <b-form-group label="انتخاب مشتری">
            <div class="d-flex col-md-6 mb-3" style="gap: 0.5rem">
              <b-form-input
                @keypress.enter.prevent="requestCustomer"
                v-model="customerMobile"
                :disabled="disabled || customerInfo"
                @input="requestCustomer"
                type="text"
              />
              <button
                @click="clearCustomer"
                v-if="customerInfo"
                class="btn btn-danger"
              >
                لغو مشتری
              </button>
            </div>
            <template v-if="customerInfo">
              <div v-if="customerInfo.customer" class="row">
                <div
                  v-for="i in [['حضوری', 'physical']]"
                  :key="i[1]"
                  class="col-6 d-flex justify-content-between px-3"
                >
                  <div>
                    شارژ کیف پول:
                    <span v-if="customerInfo.customer" class="font-weight-bold"
                      >{{
                        customerInfo.customer.wallet.balance | price
                      }}
                      تومان</span
                    >
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span
                    >
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 font-weight-bold" v-else>مشتری جدید</div>
            </template>
          </b-form-group>
          <div class="row">
            <b-form-group class="col-md-6" label="نام">
              <b-form-input type="text" v-model="firstName" />
            </b-form-group>
            <b-form-group class="col-md-6" label="نام خانوادگی">
              <b-form-input type="text" v-model="lastName" />
            </b-form-group>
          </div>
          <b-form-group class="col-12">
            <label class="" for="products">
              فروشنده <i class="text-danger">*</i></label
            >
            <div id="selectSeller">
              <button
                v-for="(seller, index) in sellers"
                :key="index"
                class="sellerBtn"
                :class="{ active: selectedSellerId == seller.id }"
                type="button"
                @click="selectedSellerFunc(seller)"
              >
                {{ seller.label }}
              </button>
            </div>
          </b-form-group>
          <b-form-group label="انتخاب محصول">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input
                autocomplete="off"
                autofocus
                ref="productSku"
                v-model="productSku"
                :disabled="disabled"
                @keypress.prevent.enter="requestProduct"
                type="text"
              />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox
                  id="refund_checkbox"
                  type="checkbox"
                  :disabled="disabled"
                  v-model="refund"
                />
              </div>
            </div>
          </b-form-group>
          <b-form-group label="جستجوی محصول" class="mb-5">
            <ProductSearch
              ref="productSearch"
              :selectable="true"
              class="row mb-5"
              :store="admin.store_id"
              :show-label="false"
              @selectVariety="selectVariety"
            />
          </b-form-group>
          <div
            v-for="i in ['varieties', 'refund_varieties']"
            v-if="$data[i] != ''"
          >
            <template>
              <h4 class="table-title">
                <template v-if="i === 'varieties'">فروش</template>
                <template v-else>مرجوع</template>
              </h4>
            </template>
            <span v-if="i === 'varieties'">
              {{ varieties.reduce((a, b) => a + b.quantity, 0) }}
            </span>
            <b-table
              class="mt-3 admin-order"
              :key="hasSelectedItem ? 'with-wallet' : 'without-wallet'"
              :class="$data[i]"
              hover
              bordered
              responsive
              :items="$data[i]"
              :fields="getFields(i)"
            >
              <template v-slot:cell(index)="data">
                <span
                  :class="{ active: data.item.has_relation_with_category_9 }"
                >
                  {{ data.index + 1 }}
                </span>
              </template>
              <template v-slot:cell(image)="data" class="text-center">
                <div class="order-product-img">
                  <a :href="getImage(data.item)">
                    <img class="w-100 h-100" :src="getImage(data.item)" />
                  </a>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <span style="width: 300px">
                  <span style="line-height: 2">{{
                    data.item.product.title
                  }}</span>
                  <span v-if="data.item.color || data.item.attributes != ''">
                    <span> | </span>
                    <span v-if="data.item.color">
                      رنگ : {{ data.item.color.name }}
                      {{ data.item.attributes != "" ? " | " : "" }}
                    </span>
                    <span v-if="data.item.attributes != ''">
                      <span
                        v-for="(attr, index) in data.item.attributes"
                        :key="index"
                      >
                        {{ attr.label + ": " + attr.pivot.value }}
                        {{
                          index != data.item.attributes.length - 1 ? " | " : ""
                        }}
                      </span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-slot:cell(quantity)="data">
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="decrement(data.item)"
                  :disabled="data.item.quantity == 1 || disabled ? true : false"
                >
                  <DashSvg />
                </button>
                <span class="px-2">{{ data.item.quantity }}</span>
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="increment(data.item)"
                  :disabled="disabled"
                >
                  <PlusSvg />
                </button>
              </template>
              <template v-slot:cell(amount)="data">
                <b-form-input
                  v-if="i !== 'varieties'"
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.price | priceinput"
                  @input="
                    (value) => {
                      data.item.price =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                >
                </b-form-input>
                <span v-else>
                  {{ data.item.price | price }}
                </span>
              </template>
              <template v-slot:cell(discount_amount)="data">
                <span
                  v-if="
                    data.item.final_price.discount_price &&
                      !editDiscount[data.item.id]
                  "
                >
                  {{ data.item.final_price.discount_price }}
                </span>
                <b-form-input
                  v-else
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.final_price.discount_price | priceinput"
                  @input="(value) => onDiscountInput(value, data.item)"
                >
                </b-form-input>
                <!-- <b-form-input  
                  v-else  
                  style="width: 80px"  
                  class="m-auto"  
                  :value="data.item.final_price.discount_price | priceinput"  
                  @input="(value) => onDiscountInput(value, data.item)"  
                >  
                </b-form-input>   -->
              </template>
              <template v-slot:cell(flash)="data">
                {{
                  data.item.product && data.item.product.active_flash != ""
                    ? data.item.product.active_flash[0].title
                    : "ندارد"
                }}
              </template>
              <template v-slot:cell(total_price)="data">
                <span v-if="data.item.final_price.amount != 0">
                  <!-- <span v-if="i !== 'varieties'">{{ (data.item.price * data.item.quantity) - (data.item.final_price.discount_price * data.item.quantity) | price }}</span> -->
                  <span v-if="i !== 'varieties'">
                    {{
                      data.item.selectedOrderItem
                        ? (data.item.selectedOrderItem.amount -
                            data.item.selectedOrderItem.spent_wallet) *
                          data.item.quantity
                        : data.item.final_price.discount_price > 0
                        ? data.item.price * data.item.quantity -
                          data.item.price *
                            data.item.quantity *
                            (data.item.final_price.discount_price / 100)
                        : (data.item.price * data.item.quantity) | price
                    }}
                  </span>
                  <span v-else>{{
                    (editDiscount[data.item.id]
                      ? data.item.final_price.amount * data.item.quantity -
                        data.item.final_price.amount *
                          data.item.quantity *
                          (data.item.final_price.discount_price / 100)
                      : data.item.final_price.amount * data.item.quantity)
                      | price
                  }}</span>
                </span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(seller_id)="data">
                <b-button @click="sellerModalHandler(data.item.id)">
                  <span>
                    {{
                      seller_ids[data.item.id] && seller_ids[data.item.id].label
                        ? seller_ids[data.item.id].label
                        : "انتخاب نشده"
                    }}
                  </span>
                  <i class="fa fa-angle-down"></i>
                </b-button>
              </template>
              <template v-slot:cell(factor_id)="data">
                <div class="d-flex flex-column align-items-center">
                  <b-form-select
                    v-if="orderItems.length > 0"
                    v-model="currentOrderItem"
                    :options="[
                      {
                        text: 'فاکتور را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...orderItems.map((order) => ({
                        text:
                          'فاکتور شماره ' +
                          order.id +
                          ' | قیمت ' +
                          order.pos_amount.toLocaleString() +
                          ' تومن',
                        value: order,
                      })),
                    ]"
                    class="w-100 mb-2"
                  />
                  <b-form-select
                    v-if="
                      currentOrderItem &&
                        currentOrderItem.mini_order_items.length > 0
                    "
                    v-model="data.item.selectedOrderItem"
                    :options="[
                      {
                        text: 'آیتم را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...currentOrderItem.mini_order_items.map((item) => ({
                        text: item.variety_name,
                        value: item,
                      })),
                    ]"
                    class="w-100"
                  />
                </div>
              </template>
              <template v-slot:cell(wallet_used)="data">
                <span v-if="data.item.selectedOrderItem">
                  {{
                    (data.item.selectedOrderItem.spent_wallet *
                      data.item.quantity)
                      | price
                  }}
                </span>
              </template>
              <template v-slot:cell(delete)="data">
                <a
                  class="action-btns1 pt-1 px-2"
                  @click="deleteItem(data.item, i)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <template v-if="varieties != '' || refund_varieties != ''">
            <div
              class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
            >
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                <span class="px-3 py-2"> {{ total | price }} تومان </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مجموع قیمت مرجوعی ها :
                </span>
                <span class="px-3 py-2"> {{ totalRefunds | price }} تومان</span>
              </div>
              <div
                v-if="hasSelectedItem"
                class="d-md-flex justify-content-between"
              >
                <span class="px-3 py-2 font-bold">
                  مجموع مبلغ مرجوعی استفاده شده از کیف پول :
                </span>
                <span class="px-3 py-2">
                  {{
                    refund_varieties.reduce((sum, item) => {
                      return (
                        sum +
                        (item.selectedOrderItem
                          ? item.selectedOrderItem.spent_wallet * item.quantity
                          : 0)
                      );
                    }, 0) | price
                  }}
                  تومان
                </span>
              </div>
                 <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> تخفیف(تومان) : </span>
                <b-form-input style="width: 130px" :value="discountAmount | priceinput" @input="
                  (value) => {
                    discountAmount =
                      value !== '' ? +value.replace(/\D/g, '') : '';
                  }
                " />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  جمع تخفیفات :
                </span>
                <!-- <span class="px-3 py-2">  
                  {{ varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                    +
                    refund_varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                  | price }} تومان  
                </span>   -->
                <span class="px-3 py-2">
                  {{ totalDiscounts | price }} تومان
                </span>
                <!-- <span class="px-3 py-2">  
                  {{ varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                    +
                    refund_varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                  | price }}   
                </span>   -->
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> فاکتور باز : </span>
                <div class="px-3 py-2">
                  <input type="checkbox" v-model="isOpen" />
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ کارت به کارت (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cardByCard_amount | priceinput"
                  @input="
                    (value) => {
                      cardByCard_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ پرداخت نقدی (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cash_amount | priceinput"
                  @input="
                    (value) => {
                      cash_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div
                v-if="
                  customerInfo &&
                    customerInfo.customer &&
                    customerInfo.customer.wallet &&
                    customerInfo.customer.wallet.balance > 0
                "
                class="d-md-flex justify-content-between"
              >
                <span class="px-3 py-2 font-bold">
                  میزان کسر از کیف پول (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="(totalRefunds > total ? 0 : walletB) | priceinput"
                  @input="
                    (value) => {
                      walletB = value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> پرداخت از پوز (ریال): </span>
                <span
                  class="px-3 py-2"
                  :class="{
                    'text-success': totalPrice >= 0,
                    'text-danger': totalPrice < 0,
                  }"
                >
                  {{ (totalPrice * 10) | price }} ریال
                </span>
              </div>
            </div>
            <div class="row mt-4">
              <b-form-group
                class="col-md-6"
                label="یادداشت"
                :label-for="'description'"
              >
                <b-form-textarea
                  id="description"
                  v-model="description"
                  placeholder="یادداشت"
                  :required="isDiscountFilled"
                />
              </b-form-group>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button
                type="submit "
                :disabled="DiasableSubmit"
                :class="{ reqDiasableStyle: DiasableSubmit }"
                class="btn btn-success"
              >
                ثبت سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')"
                >X</b-button
              >
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button
                  v-for="(seller, index) in sellers"
                  :key="index"
                  class="sellerBtn"
                  type="button"
                  @click="selectedSellerForVariety(seller)"
                >
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopCreate",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      disabled: false,
      refund: false,
      selectedSeller: null,
      selectedSellerId: null,
      seller_ids: {},
      showModal: false,
      created_at: null,
      editDiscount: {},
      discountAmount: 0,
      cardByCard_amount: null,
      cash_amount: null,
      currentOrderItem: null,
      description: null,
      sendCoupenStatus: false,
      sellers: [],
      isOpen: 0,
      selectedVarietyId: null,
      productSku: "",
      reqDiasableStyle: true,
      customerMobile: "",
      // fields: [
      //   {
      //     key: "index",
      //     label: "ردیف",
      //   },
      //   {
      //     key: "barcode",
      //     label: "بارکد",
      //   },
      //   {
      //     key: "image",
      //     label: "تصویر",
      //   },
      //   {
      //     key: "title",
      //     label: "عنوان",
      //   },
      //   {
      //     key: "amount",
      //     label: "قیمت واحد (تومان)",
      //   },
      //   {
      //     key: "quantity",
      //     label: "تعداد",
      //   },
      //   {
      //     key: "discount_amount",
      //     label: "تخفیف واحد (درصد)",
      //   },
      //   {
      //     key: "seller_id",
      //     label: "فروشنده",
      //   },
      //   {
      //     key: "flash",
      //     label: "کمپین",
      //   },
      //   {
      //     key: "total_price",
      //     label: "قیمت نهایی (تومان)",
      //   },
      //   {
      //     key: "delete",
      //     label: "حذف",
      //   },
      // ],
      varieties: [],
      refund_varieties: [],
      orderItems: [],
      firstName: "",
      lastName: "",
      customerInfo: null,
      admin: null,
      flag: true,
      coupenPrice: null,
      hasSelectedItem: false,
      tableKey: 0,
      walletB: null,
      coupen: null,
      disableCoupen: false,
      DiasableSubmit: false,
    };
  },
  computed: {
    isDiscountFilled() {
      if (this.discountAmount > 0) {
        return true;
      } else if (
        this.totalPrice <= 0 &&
        this.cardByCard_amount <= 0 &&
        this.cash_amount <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isSellItem() {
      return this.varieties.length;
    },
    totalDiscounts() {
      return this.varieties.reduce((sum, item) => {
        const qty = item.quantity || 1;
        const original = Number(item.price) || 0;
        const percent = Number(item.final_price?.discount_price) || 0;

        const discount = (original * qty * percent) / 100;
        return sum + discount;
      }, 0);
    },
    total() {
      const totalVarieties = this.varieties.reduce(
        (a, b) =>
          a +
          (b.price > 0
            ? b.price * b.quantity
            : b.final_price.amount + b.final_price.discount_price * b.quantity),
        0
      );

      return totalVarieties;
    },
    totalRefunds() {
      return this.refund_varieties.reduce((total, variety) => {
        const qty = variety.quantity || 0;
        const price = variety.price || 0;
        const amount = variety.selectedOrderItem
          ? variety.selectedOrderItem.amount
          : 0;
        const spent = variety.selectedOrderItem
          ? variety.selectedOrderItem.spent_wallet
          : 0;

        return (
          total + (variety.selectedOrderItem ? amount - spent : price) * qty
        );
      }, 0);
    },
    totalPrice() {
      const totalRefundAmount = this.refund_varieties.reduce((sum, item) => {
        let total = item.price * item.quantity;
        let discount = total * (item.final_price.discount_price / 100);
        return (
          sum +
          (item.selectedOrderItem
            ? (this.isSellItem
                ? item.selectedOrderItem.amount
                : item.selectedOrderItem.amount -
                  item.selectedOrderItem.spent_wallet) * item.quantity
            : total - discount)
        );
      }, 0);

      const totalVarietiesAmount = this.varieties.reduce((sum, item) => {
        const qty = item.quantity || 1;
        const price = Number(item.price) || 0;
        return sum + price * qty;
      }, 0);

      const isRefundMoreThanSell = totalRefundAmount > totalVarietiesAmount;

      const adjustedRefundAmount = this.refund_varieties.reduce((sum, item) => {
        let total = item.price * item.quantity;
        let discount = total * (item.final_price.discount_price / 100);
        return (
          sum +
          (item.selectedOrderItem
            ? (isRefundMoreThanSell
                ? item.selectedOrderItem.amount -
                  item.selectedOrderItem.spent_wallet
                : this.isSellItem
                ? item.selectedOrderItem.amount
                : item.selectedOrderItem.amount -
                  item.selectedOrderItem.spent_wallet) * item.quantity
            : total - discount)
        );
      }, 0);

      let totalAmount = this.total;
      totalAmount -= adjustedRefundAmount;

      totalAmount -= this.varieties.reduce((sum, item) => {
        const qty = item.quantity || 1;
        const original = Number(item.price) || 0;
        const percent = Number(item.final_price?.discount_price) || 0;
        const discount = (original * qty * percent) / 100;
        return sum + discount;
      }, 0);

      // if (totalAmount < 0) {
      //   totalAmount = totalAmount + this.refund_varieties.reduce((a, b) => a + (b.final_price.discount_price * b.quantity), 0);
      // }else{
      //   totalAmount = totalAmount - this.refund_varieties.reduce((a, b) => a + (b.final_price.discount_price * b.quantity), 0);
      // }
      let walletBalance = 0;

      if (
        this.customerInfo &&
        this.customerInfo.customer &&
        this.customerInfo.customer.wallet
      ) {
        walletBalance = this.customerInfo.customer.wallet.balance;
        if (this.walletB > walletBalance) {
          this.walletB = 0;
        }
      }

      if (this.discountAmount > 0) {
        totalAmount -= this.discountAmount;
      }
      if (this.cardByCard_amount > 0) {
        totalAmount -= this.cardByCard_amount;
      }
      if (this.cash_amount > 0) {
        totalAmount -= this.cash_amount;
      }
      if (this.walletB > 0 && this.walletB < totalAmount) {
        totalAmount -= this.walletB;
      } else if (
        this.walletB >= totalAmount &&
        this.walletB > 0 &&
        !this.refund_varieties.length
      ) {
        if (this.walletB > totalAmount) {
          this.walletB = totalAmount;
        }
        totalAmount = 0;
      }

      return totalAmount;
    },
  },
  mounted() {
    this.listenForKeyPress();
  },
  methods: {
    getFields(type) {
      const baseFields = [
        { key: "index", label: "ردیف" },
        { key: "barcode", label: "بارکد" },
        { key: "image", label: "تصویر" },
        { key: "title", label: "عنوان" },
        { key: "amount", label: "قیمت واحد (تومان)" },
        { key: "quantity", label: "تعداد" },
        { key: "discount_amount", label: "تخفیف واحد (درصد)" },
        { key: "seller_id", label: "فروشنده" },
        { key: "flash", label: "کمپین" },
        { key: "total_price", label: "قیمت نهایی (تومان)" },
        { key: "delete", label: "حذف" },
      ];

      if (type == "refund_varieties") {
        baseFields.splice(baseFields.length - 2, 0, {
          key: "factor_id",
          label: "فاکتور فروش",
        });
      }

      if (this.hasSelectedItem && type == "refund_varieties") {
        baseFields.splice(baseFields.length - 2, 0, {
          key: "wallet_used",
          label: "مبلغ استفاده شده از کیف پول",
        });
      }
      return baseFields;
    },
    async getData() {
      const responseAdmin = await this.$axios.get("admin/home");
      this.admin = responseAdmin.data.data.admin;
      const responseSeller = await this.$axios.get(
        `admin/sellers?all=1&is_active=1&store_id=${this.admin.store_id}`
      );
      this.sellers = responseSeller.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
      if (this.sellers.length == 1) {
        this.selectedSellerFunc(this.sellers[0]);
      }
    },
    checkCoupon() {
      if (this.coupenPrice) {
        this.coupenPrice = null;
        this.$root.notify(
          "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
          "warning"
        );
      }
    },
    onDiscountInput(value, item) {
      item.final_price.discount_price =
        value !== "" ? +value.replace(/\D/g, "") : "";
      this.$set(this.editDiscount, item.id, 1);
    },
    // async searchOrderInput(value, item) {
    //   this.currentOrderItems = [];
    //   if (value.length < 2) return;

    //   try {
    //     const response = await this.$axios.get("admin/mini_orders/" + value);
    //     const order = response.data.data.mini_order;

    //     if (order && order.mini_order_items) {
    // this.currentOrderItems = order.mini_order_items
    //   .filter(i => i.type === "sell")
    //   .map(i => {
    //     const spentPerUnit =
    //       i.quantity > 1
    //         ? Math.floor(i.spent_wallet / i.quantity)
    //         : i.spent_wallet;

    //     return {
    //       ...i,
    //       spent_wallet: spentPerUnit,
    //     };
    //   });
    //     }
    //   } catch (e) {
    //     console.error(e);
    //   }
    // },
    clearCoupon() {
      this.coupenPrice = null;
      this.coupen = "";
    },
    selectedSellerForVariety(seller) {
      this.seller_ids[this.selectedVarietyId] = {
        label: seller.label,
        id: seller.id,
      };
      this.closeModal("close");
    },
    selectVariety(variety) {
      console.log(variety, "variety");
      this.addVariety(variety);
    },
    async sendCoupen() {
      this.disableCoupen = true;
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      try {
        let fd = new FormData();
        fd.append("code", this.coupen);
        let reqBody = {
          mobile: this.customerMobile,
          discount_amount: this.discountAmount,
          first_name: this.firstName,
          last_name: this.lastName,
          description: this.description,
          from_wallet_amount: this.from_wallet_amount,
          varieties,
          refund_varieties,
        };
        if (this.coupen) {
          reqBody.coupon_code = this.coupen;
        }
        const response = await this.$axios.post("admin/coupon/verify", reqBody);

        this.coupenPrice = response.data.data.discount.discount;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disableCoupen = false;
      }
    },
    listenForKeyPress() {
      document.removeEventListener("keyup", this.onKeyPress);
      document.addEventListener("keyup", this.onKeyPress);
    },
    onKeyPress(e) {},
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            barcode: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify(
            "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
            "warning"
          );
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";

      const alreadyAdded = this[mode].find((v) => v.id == variety.id);
      if (alreadyAdded) {
        alreadyAdded.quantity++;
        this.$root.notify(
          "به تعداد محصول اضافه شد: " + alreadyAdded.quantity,
          "success"
        );
        return;
      }

      const v = JSON.parse(JSON.stringify(variety));

      v.flat_discount = 0;
      v.factor_id = null;
      v.quantity = 1;

      v.price = Number(v.price) || 0;
      v.final_price = v.final_price || {};
      v.final_price.amount = Number(v.final_price.amount) || 0;
      v.final_price.discount_price = Number(v.final_price.discount_price) || 0;
      v.final_price.discount = Number(v.final_price.discount) || 0;

      if (v.final_price && v.final_price.discount_type === "flat") {
        v.flat_discount = v.final_price.discount_price || 0;
        const amount = v.price || v.final_price.amount || 0;
        const discountValue = Number(v.final_price.discount_price) || 0;
        if (amount > 0) {
          v.final_price.discount_price = parseFloat(
            ((discountValue / amount) * 100).toFixed(2)
          );
        } else {
          v.final_price.discount_price = 0;
        }
      } else if (
        v.final_price &&
        v.final_price.discount_type === "percentage"
      ) {
        v.final_price.discount_price = v.final_price.discount || 0;
      }

      this.$set(v, "selectedOrderItem", null);
      this.$set(v, "factor_id", v.factor_id);
      this.$set(v, "flat_discount", v.flat_discount);

      this[mode].push(v);
      if (this.customerInfo) {
        const isRefundItem = this.refund_varieties.length == 1 ? true : false;
        if (isRefundItem && mode == "refund_varieties") {
          this.$axios
            .get("admin/mini_orders-refund-search", {
              params: {
                mobile: this.customerInfo.customer.mobile,
              },
            })
            .then((res) => {
              this.orderItems = res.data.data.mini_orders;
              console.log(this.orderItems, "this.orderItems");
            });
        }
      }

      this.seller_ids[v.id] = this.selectedSeller
        ? { label: this.selectedSeller.label, id: this.selectedSeller.id }
        : {};
    },
    selectedSellerFunc(seller) {
      this.selectedSellerId = seller.id;
      this.selectedSeller = seller;
    },
    getImage(variety) {
      if (variety.images != "") {
        return variety.images[0].url;
      }
      if (variety.product.images != "") {
        return variety.product.images[0].url;
      }
      return null;
    },
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      this.checkCoupon();
    },
    increment(variety) {
      variety.quantity++;
      this.checkCoupon();
    },
    deleteItem(variety, mode) {
      this[mode] = this[mode].filter((v) => {
        return v.id !== variety.id;
      });
      this.checkCoupon();
    },
    async requestCustomer(mobile) {
      if (mobile.length !== 11) return;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/mini_orders/customer-search",
          {
            params: {
              mobile,
            },
          }
        );
        this.disabled = false;
        const data = response.data.data;
        data.from_wallet_amount = data.from_wallet_amount || 0;
        this.customerInfo = data;
        this.walletB = this.customerInfo.customer?.wallet.balance;

        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      }
    },
    clearCustomer() {
      this.customerInfo = null;
      this.walletB = 0;
      this.customerMobile = "";
    },
    async submit() {
      console.log(this.DiasableSubmit, "this.DiasableSubmit");

      if (!this.validate()) {
        return;
      }
      let fd = new FormData();
      if (this.created_at) {
        fd.append("created_at", this.created_at);
      }
      fd.append(
        "cardByCard_amount",
        this.cardByCard_amount ? this.cardByCard_amount : 0
      );
      fd.append("store_id", this.admin.store_id);
      fd.append("mobile", this.customerMobile);
      fd.append("first_name", this.firstName);
      fd.append("last_name", this.lastName);
      fd.append("cash_amount", this.cash_amount ? this.cash_amount : 0);
      fd.append(
        "discount_amount",
        Number(this.discountAmount) +
          Number(this.coupenPrice ? this.coupenPrice : 0)
      );
      fd.append("description", this.description);
      if (this.walletB) {
        fd.append("from_wallet_amount", this.walletB);
      } else if (this.walletB == 0) {
        fd.append("from_wallet_amount", 0);
      } else if (
        this.customerInfo &&
        this.customerInfo.customer &&
        this.customerInfo.customer.wallet
      ) {
        fd.append("from_wallet_amount", 0);
      }
      if (this.isOpen == true) {
        fd.append("is_open", 1);
      } else {
        fd.append("is_open", this.isOpen);
      }
      if (this.coupen) fd.append("coupon_code", this.coupen);
      fd.append("sendCouponIsActive", this.sendCoupenStatus ? 1 : 0);
      this.varieties.forEach((item, index) => {
        fd.append(
          `varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
        );
        fd.append(`varieties[${index}][id]`, item.id);
        fd.append(`varieties[${index}][quantity]`, item.quantity);
        if (item.final_price.discount_price > 0 && this.editDiscount[item.id]) {
          fd.append(
            `varieties[${index}][amount]`,
            item.final_price.amount -
              (item.final_price.amount * item.final_price.discount_price) / 100
          );
        } else {
          fd.append(`varieties[${index}][amount]`, item.final_price.amount);
        }
        if (item.final_price.discount_price) {
          fd.append(
            `varieties[${index}][discount_amount]`,
            item.flat_discount > 0
              ? item.flat_discount
              : item.price * (item.final_price.discount_price / 100)
          );
          fd.append(`varieties[${index}][real_amount]`, item.price);
        }
      });
      this.refund_varieties.forEach((item, index) => {
        fd.append(
          `refund_varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
        );
        fd.append(`refund_varieties[${index}][id]`, item.id);
        fd.append(`refund_varieties[${index}][quantity]`, item.quantity);
        if (item.selectedOrderItem && item.selectedOrderItem.id) {
          fd.append(
            `refund_varieties[${index}][refrence_mini_order_item_id]`,
            item.selectedOrderItem.id
          );
        }
        if (item.selectedOrderItem && item.selectedOrderItem.spent_wallet) {
          fd.append(
            `refund_varieties[${index}][charging_wallet]`,
            item.selectedOrderItem.spent_wallet
          );
        }
        if (item.selectedOrderItem && item.selectedOrderItem.amount) {
          fd.append(
            `refund_varieties[${index}][amount]`,
            item.selectedOrderItem.amount - item.selectedOrderItem.spent_wallet
          );
        } else if (
          item.final_price.discount_price &&
          this.editDiscount[item.id]
        ) {
          fd.append(
            `refund_varieties[${index}][amount]`,
            item.final_price.amount -
              (item.final_price.amount * item.final_price.discount_price) / 100
          );
        } else {
          fd.append(`refund_varieties[${index}][amount]`, item.price);
        }
        if (item.final_price) {
          fd.append(`refund_varieties[${index}][real_amount]`, item.price);
        }
        if (item.final_price.discount_price) {
          fd.append(
            `refund_varieties[${index}][discount_amount]`,
            item.flat_discount > 0
              ? item.flat_discount
              : item.price * (item.final_price.discount_price / 100)
          );
        }
      });
      try {
        this.reqDiasableStyle = false;
        this.DiasableSubmit = true;

        this.disabled = true;
        const response = await this.$axios.post("admin/mini_orders", fd);

        const miniOrder = response.data.data.mini_order;
        this.$root.notify(response.data.message, "success");
        this.$router.push(`/admin/shop/orders/${miniOrder.id}?print=1`);
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
        this.DiasableSubmit = false;
      }
    },
    validate() {
      if (
        (!this.varieties || !this.varieties.length) &&
        !this.refund_varieties &&
        !this.refund_varieties.length
      ) {
        this.$root.warningNotify("حداقل انتخاب یک تنوع الزامی است");
        return false;
      }
      return true;
    },
  },
  watch: {
    refund_varieties: {
      handler(newVal) {
        console.log(newVal, "newVal");
        this.hasSelectedItem = !!(
          this.currentOrderItem &&
          this.currentOrderItem.mini_order_items.length > 0
        );
      },
      deep: true,
    },
    currentOrderItem: {
      handler(newVal) {
        if (!newVal || !newVal.mini_order_items) return;

        newVal.mini_order_items = newVal.mini_order_items
          .filter((i) => i.type === "sell")
          .map((i) => {
            const baseSpent = i.original_spent_wallet ?? i.spent_wallet;

            const spentPerUnit =
              i.quantity > 1 ? Math.floor(baseSpent / i.quantity) : baseSpent;

            return {
              ...i,
              spent_wallet: spentPerUnit,
              original_spent_wallet: baseSpent,
            };
          });
      },
      deep: false,
    },
    discountAmount(newValue) {
      this.checkCoupon();
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.table-responsive {
  height: auto;
}

.reqDiasableStyle {
  cursor: not-allowed;
  opacity: 0.5;
}

.order-product-img {
  max-width: 50px;
  margin: auto;
}

.table-title {
  font-weight: bold;
}
</style>
<style>
.admin-order table tr:has(span.active) {
  background: #007bff21;
}

.admin-order table tr:has(span.active):hover {
  background-color: #007bff21 !important;
  cursor: pointer;
}

.card.little.info {
  background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
}

.card.little.online {
  background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
}

.card.little.physical {
  background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
}

.card.little .card-header {
  font-weight: bold;
}

form#coupenCode input[type="submit"] {
  background-color: #1d99ff;
  color: white;
}

form#coupenCode input {
  padding: 4px 8px;
  border: 2px solid #1d99ff;
}

.disableCoupen {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

button#sendCoupen {
  display: flex;
  align-items: center;
  gap: 8px;
}

button#sendCoupen input {
  transform: scale(1.5);
}

.btnprimary {
  color: #fff !important;
  background-color: #0075ff;
  border-color: #3366ff;
}

.btnprimary:hover {
  background-color: #0256b8;
}

.btnprimary:hover input[type="checkbox"] {
  accent-color: #0256b8;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(6, 2fr);
  gap: 12px;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(10, 4fr);
  gap: 8px;
}

.mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
  overflow: visible;
}

div#selectSellerModal {
  position: fixed;
  inset: 0;
  background: #11221194;
  z-index: 10000;
}

div#selectSellerModalContainer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
</style>
